import React, { useContext } from 'react';

import type { TimeDisplayFormat } from '../components/EventStatus/types';

export interface DisplayConfigContextValue {
  timeDisplayFormat: TimeDisplayFormat | undefined;
}

export const DisplayContext = React.createContext<DisplayConfigContextValue>({
  timeDisplayFormat: undefined
});

const DisplayConfigProvider: React.FC<{ timeFormat?: TimeDisplayFormat }> = ({
  children,
  ...props
}) => (
  <DisplayContext.Provider value={{ timeDisplayFormat: props.timeFormat }}>
    {children}
  </DisplayContext.Provider>
);

export const useDisplayConfig = () => useContext(DisplayContext);

export default DisplayConfigProvider;
